import { createContext } from 'react';

export interface NetworkContextType {
  isOnline: boolean;
  isOffline: boolean;
  showNetworkError: boolean;
  hideNetworkError: () => void;
}

export const NetworkContext = createContext<NetworkContextType | undefined>(undefined);
